var exports = {
  "v": "relatedCards__bB5KTW",
};

module.exports = exports;
